<template>
  <div>
    <ft-navbar :expand="true"></ft-navbar>
    <header class="masthead">
      <div class="container">
        <div class="intro-text">
          <div class="intro-lead-in">Elegant und zeitlos</div>
          <div class="intro-heading text-uppercase">Stuckaturen</div>
          <router-link class="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
                       :to="{ name: 'home', params: { section: 'products' }}">Produkte
          </router-link>
        </div>
      </div>
    </header>
    <div ref="content">
      <section id="products">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <h2 class="section-heading text-uppercase">Produkte</h2>
            </div>
          </div>
          <div>
            <grid gap="2em" min="300px" class="mt-5">
              <div class="scard">
                <div class="scard-img-cnt">
                  <b-link :to="{ name: 'rosette'}">
                    <b-img-lazy src="../assets/cat/rosetten.png" blank-width="200" blank-height="200"
                                blank-color="#212529"
                                alt="Rosetten"
                                class="scard-img-top"></b-img-lazy>
                  </b-link>
                </div>
                <div class="scard-body">
                  <h4 class="scard-title">Rosetten</h4>
                </div>
                <div class="scard-footer">
                  <div>
                    <b-button block :to="{ name: 'rosette'}" variant="primary">Zur Auswahl</b-button>
                  </div>
                </div>
              </div>
              <div class="scard">
                <div class="scard-img-cnt">
                  <b-link :to="{ name: 'eckgesimse'}">
                    <b-img-lazy src="../assets/cat/eckgesimse.png" blank-width="200" blank-height="200"
                                blank-color="#212529"
                                alt="Eckgesimse"
                                class="scard-img-top"></b-img-lazy>
                  </b-link>
                </div>
                <div class="scard-body">
                  <h4 class="scard-title">Eckgesimse</h4>
                </div>
                <div class="scard-footer">
                  <div>
                    <b-button block :to="{ name: 'eckgesimse'}" variant="primary">Zur Auswahl</b-button>
                  </div>
                </div>
              </div>
              <div class="scard">
                <div class="scard-img-cnt">
                  <b-link :to="{ name: 'deckenstaebe'}">
                    <b-img-lazy src="../assets/cat/begleitstaebe.png" blank-width="200" blank-height="200"
                                blank-color="#212529"
                                alt="Deckenstäbe"
                                class="scard-img-top"></b-img-lazy>
                  </b-link>
                </div>
                <div class="scard-body">
                  <h4 class="scard-title">Deckenstäbe</h4>
                </div>
                <div class="scard-footer">
                  <div>
                    <b-button block :to="{ name: 'deckenstaebe'}" variant="primary">Zur Auswahl</b-button>
                  </div>
                </div>
              </div>
              <div class="scard">
                <div class="scard-img-cnt">
                  <b-link :to="{ name: 'zierstaebe'}">
                    <b-img-lazy src="../assets/cat/zierstaebe.png" blank-width="200" blank-height="200"
                                blank-color="#212529"
                                alt="Zierstäbe"
                                class="scard-img-top"></b-img-lazy>
                  </b-link>
                </div>
                <div class="scard-body">
                  <h4 class="scard-title">Zierstäbe</h4>
                </div>
                <div class="scard-footer">
                  <div>
                    <b-button block :to="{ name: 'zierstaebe'}" variant="primary">Zur Auswahl</b-button>
                  </div>
                </div>
              </div>
              <div class="scard">
                <div class="scard-img-cnt">
                  <b-link :to="{ name: 'einzelstuecke'}">
                    <b-img-lazy src="../assets/cat/einzelstuecke.png" blank-width="200" blank-height="200"
                                blank-color="#212529"
                                alt="Spezialitäten"
                                class="scard-img-top"></b-img-lazy>
                  </b-link>
                </div>
                <div class="scard-body">
                  <h4 class="scard-title">Einzelstücke</h4>
                </div>
                <div class="scard-footer">
                  <div>
                    <b-button block :to="{ name: 'einzelstuecke'}" variant="primary">Zur Auswahl</b-button>
                  </div>
                </div>
              </div>
            </grid>
          </div>
        </div>
      </section>
      <section class="bg-light" id="manufacturing">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <h2 class="section-heading text-uppercase">Herstell&shy;ung</h2>
              <h3 class="section-subheading text-muted">Stuckaturen werden bei uns auch heute noch in Handarbeit aus
                reinem Gips hergestellt.</h3>
              <p>
                Zur Armierung der Elemente werden Juten-, Sisal- oder auch Glasfasern eingebettet. Die linearen Elemente
                werden mit Schablonen gezogen, während die ornamentierten Stuckaturen in Silikon- Kautschuk- Formen
                gegossen werden.
              </p>
              <p>
                In unserem Atelier werden die Zugschablonen so wie die Gussformen in handarbeit hergestellt. Dies
                erlaubt uns Elemente nach Kundenwunsch herzustellen.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="card-deck mt-5">
                <div class="card" style="width: 18rem;">
                  <b-img-lazy class="card-img-top" src="../assets/zug.jpg" alt="Schablonen"></b-img-lazy>
                  <div class="card-body">
                    <p class="card-text">Linearen Elemente werden mit Schablonen gezogen</p>
                  </div>
                </div>
                <div class="card" style="width: 18rem;">
                  <b-img-lazy class="card-img-top" src="../assets/guss.jpg"
                              alt="Frästisch Detail"></b-img-lazy>
                  <div class="card-body">
                    <p class="card-text">Ornamentierte Elemente werden in Silikon- Kautschuk- Formen gegossen</p>
                  </div>
                </div>
              </div>
              <div class="card-deck mt-4">
                <div class="card" style="width: 18rem;">
                  <b-img-lazy class="card-img-top" src="../assets/zug_rund.jpg"
                              alt="Frästisch Einsatz"></b-img-lazy>
                  <div class="card-body">
                    <p class="card-text">
                      Herstellung eines runden Elementes im Ziehverfahren.</p>
                  </div>
                </div>
                <div class="card" style="width: 18rem;">
                  <b-img-lazy class="card-img-top" src="../assets/rosete-restauration.jpg"
                              alt="Frästisch Vorhangschiene"></b-img-lazy>
                  <div class="card-body">
                    <p class="card-text">Negativ-Form einer Rosette</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="references">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <h2 class="section-heading text-uppercase">Referenzen</h2>
              <h3 class="section-subheading text-muted">Beispielanwendungen von Stuckaturen.</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="card-deck mt-5">
                <div class="card" style="width: 18rem;">
                  <b-img-lazy class="card-img-top" src="../assets/stuck-im-neubau.jpg" alt="Stuck Neubau"></b-img-lazy>
                  <div class="card-body">
                    <p class="card-text">Stuckaturen werden oft auch im Um- oder Neubau angewendet.</p>
                  </div>
                </div>
                <div class="card" style="width: 18rem;">
                  <b-img-lazy class="card-img-top" src="../assets/stuck-im-neubau_2.jpg"
                              alt="Frästisch Detail"></b-img-lazy>
                  <div class="card-body">
                    <p class="card-text">Stuckaturen im Neubau mit Kaschierung der Vorhangschiene.</p>
                  </div>
                </div>
                <div class="card" style="width: 18rem;">
                  <b-img-lazy class="card-img-top" src="../assets/stuck-im-neubau_3.jpg"
                              alt="Frästisch Detail"></b-img-lazy>
                  <div class="card-body">
                    <p class="card-text">Rosette als Deckenverkleidung.</p>
                  </div>
                </div>
              </div>
              <div class="card-deck mt-4">
                <div class="card" style="width: 18rem;">
                  <b-img-lazy class="card-img-top" src="../assets/restauration.jpg"
                              alt="Frästisch Einsatz"></b-img-lazy>
                  <div class="card-body">
                    <p class="card-text">Restauration bestehender Decke.</p>
                  </div>
                </div>
                <div class="card" style="width: 18rem;">
                  <b-img-lazy class="card-img-top" src="../assets/restauration_2.jpg"
                              alt="Frästisch Vorhangschiene"></b-img-lazy>
                  <div class="card-body">
                    <p class="card-text">Restauration bestehender Stuckelemente.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="contact">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <h2 class="section-heading text-uppercase">Kontakt</h2>
              <h3 class="section-subheading text-muted">Wir unterstützen dich gerne bei deinen Projekten</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-md-4">
                  <address>
                    <strong>Wenger Hess & Partner GmbH</strong><br>
                    Morgenstrasse 1<br>
                    3073 Gümligen<br>
                    <br>
                    Telefon: 031 351 30 80<br>
                    Fax: 031 352 74 54<br>
                    <br>
                    <a href="mailto:info@wengerhess.ch">info@wengerhess.ch</a>
                  </address>
                </div>
                <div class="col-md-8">
                  <div class="rmap">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2724.512428676727!2d7.498264915990563!3d46.93196697914576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478e39d09c6d4939%3A0x647404ef89d92e68!2sWenger%2C+Hess+%26+Partner+GmbH!5e0!3m2!1sen!2sni!4v1527998981146"
                      width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ftNavbar from '@/components/FTNavbar'
import Grid from '@/components/Grid'

function scrollTo (params) {
  let el = document.getElementById('whstuck')
  if (params.hasOwnProperty('section')) {
    el = document.getElementById(params.section)
  }
  if (el) {
    window.scroll({top: el.offsetTop - 54, left: 0, behavior: 'smooth'})
  }
}

export default {
  name: 'Start',
  components: {ftNavbar, Grid},
  mounted () {
    scrollTo(this.$route.params)
  },
  beforeRouteUpdate (to, from, next) {
    scrollTo(to.params)
    next()
  }
}
</script>

<style lang="scss">
  @import "../styles/variables";
  @import "../styles/mixins";

  .wh-section {
    background-color: lighten($primary, 20%);
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.4s;
    color: $primary;
    &:hover, &:focus {
      text-decoration: none;
    }
    &:hover {
      background-color: $gray-100;
      color: darken($primary, 10%);
    }
  }

  div.rmap {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;

    iframe {
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      position: absolute;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Start.vue